function setCityCookie(city) {
    document.cookie = "userCity=" + city + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
}

function getCityCookie() {
    var name = "userCity=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return "";
}


if (Shopify.designMode) {
    setCityCookie('Bangalore');
}

function isCityCookieSet() {
    return document.cookie.split(';').some((cookie) => cookie.trim().startsWith('userCity='));
}

function getCookie(name) {
    if(Shopify.designMode) {
        return "Bangalore"
    }

// Split cookie string and get all individual name=value pairs in an array
let cookieArr = document.cookie.split(";");

// Loop through the array elements
for(let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split("=");

    /* Removing whitespace at the beginning of the cookie name
    and compare it with the given string */
    if(name == cookiePair[0].trim()) {
        // Decode the cookie value and return
        return decodeURIComponent(cookiePair[1]);
    }
}

// Return null if not found
return null;
}

if(window.location.pathname.includes('delhi') && !isCityCookieSet() && !Shopify.designMode) {
    setCityCookie("Delhi");
} else if(window.location.pathname.includes('mumbai') && !isCityCookieSet() && !Shopify.designMode) {
    setCityCookie("Mumbai");
} else if(window.location.pathname.includes('hyderabad') && !isCityCookieSet() && !Shopify.designMode) {
    setCityCookie("Hyderabad");
} else if(!isCityCookieSet() && !Shopify.designMode) {
    setCityCookie("Bangalore");
}

// Shopflo: intercept cart icon clicks
// FIX (19-Aug-2026): persist delivery details / Personal Message as cart attributes
// before showing the Shopflo cart, so order-level attributes are always up to date.
document.addEventListener('click', function(e) {
  var trigger = e.target.closest('[aria-controls="cart-drawer"]');
  if (!trigger) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  if (typeof window.saveDeliveryDetailsToCart === 'function') {
    window.saveDeliveryDetailsToCart().finally(function() {
      if (typeof handleFloCartBtn === 'function') handleFloCartBtn();
    });
  } else if (typeof handleFloCartBtn === 'function') {
    handleFloCartBtn();
  }
}, true);

// Shopflo: intercept buy-now
// Save delivery details before Shopflo starts checkout.

document.addEventListener('click', function(e) {

  var btn =
    e.target.closest('#flo-buy-now-button');

  if (!btn) {
    return;
  }

  e.preventDefault();
  e.stopImmediatePropagation();

  console.log(
    'Shopflo Buy Now clicked - saving delivery details first'
  );

  /* -----------------------------------------
     SAVE DELIVERY DETAILS
  ----------------------------------------- */

  if (
    typeof window.saveDeliveryDetailsToCart ===
    'function'
  ) {

    window.saveDeliveryDetailsToCart()

      .then(function() {

        console.log(
          'Delivery details saved. Continuing to Shopflo.'
        );

        /* -----------------------------------------
           CONTINUE WITH SHOPFLO
        ----------------------------------------- */

        if (
          typeof handleFloBuyNowBtn ===
          'function'
        ) {

          handleFloBuyNowBtn(e);

        } else {

          console.error(
            'Shopflo handleFloBuyNowBtn function not found.'
          );

        }

      })

      .catch(function(error) {

        console.error(
          'Buy Now stopped because delivery details could not be saved.',
          error
        );

      });

  } else {

    console.warn(
      'saveDeliveryDetailsToCart() is not available. Continuing with Shopflo.'
    );

    if (
      typeof handleFloBuyNowBtn ===
      'function'
    ) {

      handleFloBuyNowBtn(e);

    }

  }

}, true);

// Shopflo: intercept checkout button clicks
// FIX (19-Aug-2026): persist delivery details / Personal Message as cart attributes
// before proceeding to Shopflo checkout.
document.addEventListener('click', function(e) {
  var btn = e.target.closest('#checkout2');
  if (!btn) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  if (typeof window.saveDeliveryDetailsToCart === 'function') {
    window.saveDeliveryDetailsToCart().finally(function() {
      if (typeof handleFloCheckoutBtn === 'function') handleFloCheckoutBtn();
    });
  } else if (typeof handleFloCheckoutBtn === 'function') {
    handleFloCheckoutBtn();
  }
}, true);

// Shopflo: intercept cart-drawer open/show to show Shopflo cart instead
customElements.whenDefined('cart-drawer').then(function() {
  var CartDrawerClass = customElements.get('cart-drawer');
  if (!CartDrawerClass) return;

  var methodNames = ['open', 'show'];
  methodNames.forEach(function(method) {
    if (typeof CartDrawerClass.prototype[method] === 'function') {
      var original = CartDrawerClass.prototype[method];
      CartDrawerClass.prototype[method] = function() {
        if (typeof handleFloCartBtn === 'function') { handleFloCartBtn(); return; }
        return original.apply(this, arguments);
      };
    }
  });
});
